export default function () {
  return {
    errors: {},
    postList: [],
    loadingPosts: false,
    postSearchQuery: null,
    redirect: {
      id: null,
      source: '',
      post: '',
      type: 301,
    },
  }
}
